import { JSONType } from "Typings/Global";
import { Tag } from "./@types";

export const parseTag = (res: JSONType): Tag => {
    return ({
        ...res
    } as Tag)
}